module.exports = __webpack_public_path__ + "img/fuzion-poster-image.a499dbbb.jpg";